<div class="side-nav" [class.visible]="isVisible" [class.expanded]="mode === 'expanded'" [class.collapsed]="mode === 'collapsed'">
  @if (mode === 'collapsed') {
    <app-side-nav-collapsed [navItems]="navItems" (logout)="logout()" (toggle)="toggleNav()"></app-side-nav-collapsed>
  } @else {
    <app-side-nav-expanded [navItems]="navItems" (logout)="logout()" (toggle)="toggleNav()"></app-side-nav-expanded>
  }
</div>
